import { ADD, DELETE, EDIT, LIST, VIEW } from "const"
import { deepCopy } from "client/utils"
import {
    AccountPermissionItem,
    ProjectPermissionItem,
    CommonPermissionItem,

    AccountPermissionRow,
    ProjectPermissionRow,
    CommonPermissionRow,

    PermissionStructure,
    PermissionType,

    AccountPermissions,
    ProjectPermissions,
    CommonPermissions,

    AccountPermissionsSectioned,
    ProjectPermissionsSectioned,
    CommonPermissionsSectioned,
} from "./types"


const permissionTypes = [LIST, VIEW, ADD, EDIT, DELETE]

export const accountPermissionItem: AccountPermissionItem = {
    groups: [],
    users: [],
}
export const projectPermissionItem: ProjectPermissionItem = {
    accountGroups: [],
    projectGroups: [],
    users: [],
}
export const commonPermissionItem: CommonPermissionItem = {
    accountGroups: [],
    projectGroups: [],
    users: [],
}


export const accountPermissionRow: AccountPermissionRow = {
    title: null,
    list: { ...accountPermissionItem },
    view: { ...accountPermissionItem },
    add: { ...accountPermissionItem },
    edit: { ...accountPermissionItem },
    delete: { ...accountPermissionItem },
    customizable: false,
}
export const projectPermissionRow: ProjectPermissionRow = {
    title: null,
    list: { ...projectPermissionItem },
    view: { ...projectPermissionItem },
    add: { ...projectPermissionItem },
    edit: { ...projectPermissionItem },
    delete: { ...projectPermissionItem },
    customizable: false,
}
export const commonPermissionRow: CommonPermissionRow = {
    title: null,
    list: { ...commonPermissionItem },
    view: { ...commonPermissionItem },
    add: { ...commonPermissionItem },
    edit: { ...commonPermissionItem },
    delete: { ...commonPermissionItem },
    customizable: false,
}


export const copyPermissionRow = (
    structure: PermissionStructure,
    rowObj: AccountPermissionRow | ProjectPermissionRow | CommonPermissionRow,
) => {
    const permissions: AccountPermissions | ProjectPermissions | CommonPermissions = {}
    const permissionsSectioned: AccountPermissionsSectioned | ProjectPermissionsSectioned | CommonPermissionsSectioned = {}

    Object.keys(structure).forEach((section) => {
        permissionsSectioned[section] = {}

        structure[section].forEach((permission) => {
            permissions[permission.permissionId] = { ...rowObj, title: permission.title }
            permissionsSectioned[section][permission.permissionId] = { ...rowObj, title: permission.title }

            if (permission.unused && permission.unused.length) {
                permission.unused.forEach((type) => {
                    permissions[permission.permissionId][type] = null
                    permissionsSectioned[section][permission.permissionId][type] = null
                })
            }
        })
    })
    return { permissions, permissionsSectioned }
}


export const copyAccountPermission = (
    origin: AccountPermissionRow,
    target: AccountPermissionRow,
    copyUsers: boolean,
    copyCustomize: boolean,
) => {
    const newOrigin: AccountPermissionRow = deepCopy(origin)
    permissionTypes.forEach((type: PermissionType) => {
        if (newOrigin[type] && target && target[type]) {
            const { groups, users } = target[type]
            newOrigin[type] = {
                groups,
                users: copyUsers ? users : [],
            }
        }
    })
    if (target && copyCustomize) {
        newOrigin.customizable = target.customizable
    }
    return newOrigin
}

export const copyProjectPermission = (
    origin: ProjectPermissionRow,
    target: ProjectPermissionRow,
    copyUsers: boolean,
    copyCustomize: boolean,
) => {
    const newOrigin: ProjectPermissionRow = deepCopy(origin)
    permissionTypes.forEach((type: PermissionType) => {
        if (newOrigin[type] && target && target[type]) {
            const { accountGroups, projectGroups, users } = target[type]
            newOrigin[type] = {
                accountGroups,
                projectGroups,
                users: copyUsers ? users : [],
            }
        }
    })
    if (target && copyCustomize) {
        newOrigin.customizable = target.customizable
    }
    return newOrigin
}

export const copyCommonPermission = (
    origin: CommonPermissionRow,
    target: CommonPermissionRow,
    copyUsers: boolean,
) => {
    const newOrigin: CommonPermissionRow = deepCopy(origin)
    permissionTypes.forEach((type: PermissionType) => {
        if (newOrigin[type] && target && target[type]) {
            const { accountGroups, projectGroups, users } = target[type]
            newOrigin[type] = {
                accountGroups,
                projectGroups,
                users: copyUsers ? users : [],
            }
        }
    })
    if (target) {
        newOrigin.customizable = target.customizable
    }
    return newOrigin
}
